<template>
    <div class="pa-12">
        <!-- Nevigater -->
        <v-layout mb-6>
            <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
                <span>ข้อมูลจำนวนโครงร่างในแต่ละปี</span>
            </v-flex>
        </v-layout>
        <div class="container">
            <LineChart />
        </div>
        <v-layout mb-6>
            <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
                <span>ข้อมูลจำนวนประเภทโครงการ รายปี</span>
            </v-flex>
        </v-layout>
        <div class="container">
            <BarChart />
        </div>
    </div>

</template>

<script>
import Loading from 'vue-loading-overlay';
import LineChart from '../components/chart/LineChart'
import BarChart from '../components/chart/Bar'

export default {
    name: "Dashboard",
    data: () => ({

    }),
    components: {
        Loading,
        LineChart,
        BarChart
    },
    computed: {

    }
}
</script>

<style lang="scss">
.small {
    max-width: 600px;
    margin: 150px auto;
}

// V-select
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__selected

/*.style-chooser .vs__dropdown-menu:hover*/
    {
    background: #3E7662;
    border: solid 2px #3E7662;
    color: #fff;
    /*text-transform: lowercase;*/
    /*font-variant: small-caps;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #fff;
}
</style>
